export default "__VITE_ASSET__DBLwqtwo__"